import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'

import Font from '@cred/react-font'
import { extractNumber } from '@cred/shared/utils'

import MoneyInput from 'components/money-input'

import { savingsCalculatorContext } from '../analytics'
import {
  SAVINGS_CALCULATOR_REDUX_FORM_NAME,
  LOAN_AMOUNT_FIELD_NAME,
  LOAN_AMOUNT_FIELD_LABEL,
  LOAN_AMOUNT_CEILING,
  LOAN_AMOUNT_FLOOR,
} from '../constants'
import styles from './styles.module.scss'

let editorInputValue = ''

const amountIsValid = (value) => {
  const amount = extractNumber(value)

  // eslint-disable-next-line
  if (isNaN(amount)) {
    return true
  }

  if (amount < LOAN_AMOUNT_FLOOR || amount > LOAN_AMOUNT_CEILING) {
    return false
  }

  return true
}

const validateLoanAmount = (value) => {
  if (!amountIsValid(value)) {
    return 'Enter amount ($600 to $100,000)'
  }

  return undefined
}

const generateHandleInputChange = (change) => (e) => {
  const inputValue = e.target.value

  if (inputValue === '' || extractNumber(inputValue) <= LOAN_AMOUNT_CEILING) {
    editorInputValue = inputValue
    return
  }

  // We will reset the form if the desired input is above our max loan amount
  setTimeout(() => change(LOAN_AMOUNT_FIELD_NAME, editorInputValue))
}

const LoanAmountForm = ({ change }) => (
  <div className={styles.loanAmountFormRoot}>
    <Font color="lighter" weight="semiBold" type="bodySmall" className="align-center">
      {LOAN_AMOUNT_FIELD_LABEL}
    </Font>
    <MoneyInput
      inputStyles={{ dollarSign: styles.dollarSign, label: styles.label }}
      label={LOAN_AMOUNT_FIELD_LABEL}
      className={styles.inputField}
      name={LOAN_AMOUNT_FIELD_NAME}
      id="calculator-input"
      icon={false}
      prefix="$"
      placeholder="$0"
      onChange={generateHandleInputChange(change)}
      validate={[validateLoanAmount]}
      analyticsContexts={savingsCalculatorContext}
      exposeValue
    />
    <Font
      color="neutral"
      weight="semiBold"
      type="disclaimer"
      className={`${styles.subLabel} align-center mt-8`}
    >
      Please enter between $600 and $100,000
    </Font>
  </div>
)

LoanAmountForm.propTypes = {
  // Comes from redux form to force a form change
  change: PropTypes.func,
}

export { amountIsValid, validateLoanAmount, generateHandleInputChange, LoanAmountForm }

export default reduxForm({ form: SAVINGS_CALCULATOR_REDUX_FORM_NAME })(LoanAmountForm)
